module.exports = __webpack_public_path__ + "img/温姆1_1.209dc783.png";